import { useMemo } from 'react';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useApplication } from '/utilities/application';
import { useTranslation } from '/utilities/i18n';

export const useAccountMenuItems = () => {
	const { routes } = useNavigator();
	const { isApplication } = useApplication();
	const { logout, loggedIn, userData } = useAuth();
	const { t } = useTranslation();

	const accountMenu = useMemo(
		() => [
			...Object.keys(routes.account.children)
				.map((routeKey) => ({
					...routes.account.children[routeKey],
					key: routeKey,
				}))
				.filter(
					(route) =>
						!route.hideFromMenu &&
						!(route.hideOnWeb && !isApplication) &&
						(
							route.layoutProps?.accessCheck === undefined || route.layoutProps.accessCheck({ userRole: userData?.role })
						)
				)
				.map((route) => ({
					navLink: true,
					exact: false,
					tag: 'link',
					title: route.head.title,
					route: route,
					icon: route.menuIcon,
					restricted: !!route.layoutProps?.accessCheck,
				})),
			...(loggedIn
				? [
						{
							tag: 'button',
							type: 'button',
							className: 'no-arrow',
							onClick: logout,
							title: t('Çıkış'),
							icon: 'logout',
						},
					] : []),
		],
		[isApplication, loggedIn, logout, routes, t, userData]
	);

	return accountMenu;
};

export default useAccountMenuItems;
